import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {
  useUpdateSubscriptionApi,
  type UpdateSubscriptionApiPayload,
} from "../../../../react-query-hooks/store/subscriptions/update-subscription";

export function useEditSubscriptionHook() {
  const navigate = useNavigate();
  const updateMutation = useUpdateSubscriptionApi();

  const editSubscription = (
    subscriptionId: number,
    payload: UpdateSubscriptionApiPayload
  ) => {
    updateMutation.mutate(
      {subscriptionId, payload},
      {
        onSuccess: () => {
          message.success("Updated successfully");
          navigate("/products?activeTab=subscriptions");
        },
      }
    );
  };

  return {
    editSubscription,
    isEditingSubscription: updateMutation.isLoading,
  };
}
